import { render, staticRenderFns } from "./birthdaySetting.vue?vue&type=template&id=d0c69e86&scoped=true&"
import script from "./birthdaySetting.vue?vue&type=script&lang=js&"
export * from "./birthdaySetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c69e86",
  null
  
)

export default component.exports